import { useEffect, useRef, useState } from "react";

import { Button, Divider, Flex, Form, Modal, Select, Space } from "antd";
import moment from "moment";
import { useModalForm } from "../../../../../utils/hooks/useModalForm";
import MainPagetitle from "../../../../layouts/MainPagetitle";
import ApplicationCard from "./ApplicationCard";
import ApplicationSearch from "./ApplicationSearch/ApplicationSearch";

const Applications = (props) => {
  const isAdmin = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.admin;
  const isOps = props?.$store?.user?.role === _enum.ROUTE_PERSONAS.ops;
  // pagination & sorting
  const [search, setSearch] = useState({
    page: 1,
    limit: 10,
    order_by: "updatedAt",
    order_direction: "DESC",
  });

  // flags
  const [tableData, setTableData] = useState([]);
  const [isFetching, setIsFetching] = useState(true);

  const [editData, setEditData] = useState(null);
  const initialColumnsRef = useRef([
    {
      dataIndex: "created_by",
      title: "Employee Name",
      render: (text, record) => (
        <>
          <span className="text-primary">
            {record?.created_by?.full_name || "-"}
          </span>
        </>
      ),
      display: isAdmin ? true : false,
    },
    {
      dataIndex: "customer_name",
      title: "Customer Name",
      render: (text, record) => (
        <>
          <span className="text-primary">{text}</span>
        </>
      ),
    },
    { dataIndex: "mobile_number", title: "Mobile No." },
    {
      dataIndex: "product_type",
      title: "Loan Type",
      render: (text) => {
        return <>{_enum.LOAN_TYPES_MAP[text]}</>;
      },
    },
    {
      dataIndex: "source",
      title: "Source",
      render: (text) => text?.toTitleCase() || "-",
    },
    {
      dataIndex: "bank_name",
      title: "Bank Name",
    },
    {
      dataIndex: "loan_amount",
      title: "Loan Amt",
      render: (text) => {
        return <>{text?.cur(0) || "-"}</>;
      },
    },
    {
      dataIndex: "application_number",
      title: "Application No.",
    },
    {
      dataIndex: "application_date",
      title: "Application Date",
      render: (text) =>
        text ? new Date(text).dateToDDMMYYYY(new Date(text)) : "-",
    },
    {
      dataIndex: "application_status",
      title: "Application Status",
      render: (text) => (
        <AppTag color={_enum.STATUS_COLOR_MAP[text?.toLowerCase()]}>
          {text?.toTitleCase() || "-"}
        </AppTag>
      ),
    },
  ]);

  const [columns, setColumns] = useState(initialColumnsRef.current);
  const logColumns = [
    {
      title: "Transaction Date",
      dataIndex: "transaction_date",
      render: (text) => {
        let date = new Date(text).dateToDDMMYYYY(new Date(text));
        return date;
      },
    },
    {
      title: "Login Status",
      dataIndex: "status",
      render: (text) => {
        return (
          <AppTag size="sm" color={_enum.STATUS_COLOR_MAP[text.toLowerCase()]}>
            {text?.toTitleCase() || "-"}
          </AppTag>
        );
      },
    },
    { title: "Updated By", dataIndex: "updated_by_id" },
    { title: "Remarks", dataIndex: "remarks" },
  ];
  const [rowcount, setRowcount] = useState(0);

  // useModalForm
  const modalConfigs = {
    applicationInfo: [
      {
        name: "customer_name",
        label: "Customer Name",
        type: "text",
        placeholder: "Please Enter",
        required: true,
        disableOnEdit: isAdmin ? false : true,
      },
      {
        name: "mobile_number",
        label: "Mobile No.",
        type: "text",
        rules: _enum.MOBILE_NUM_RULE,
        placeholder: "Please Enter",
        required: true,
        disableOnEdit: isAdmin ? false : true,
      },
      {
        name: "product_type",
        label: "Product Type",
        type: "select",
        options: [],
        fetchOptions: () => props.apis.apiGetProductTypes(),
        placeholder: "Please enter",
        required: true,
      },
      {
        label: "Bank Name",
        name: "bank_name",
        type: "select",
        options: [],
        fetchKey: "bank_name",
        fetchOptions: async () => {
          const data = await props.apis.apiGetBanknames();
          if (data) return data;
          return [];
        },
        placeholder: "Please Select",
      },
      {
        name: "source",
        label: "Source",
        type: "select",
        options: [{ key: "SELF", label: "Self" }],
        disableOnEdit: true,
      },
      {
        name: "loan_amount",
        label: "Loan Amt",
        type: "number",
        placeholder: "Please Enter",
      },
      {
        label: "Application Status",
        name: "application_status",
        type: "select",
        options: _enum.APPLICATION_LOAN_STATUS,
        freezeOptionsIn: ["edit", "add"],
        allowedOptionsMap: {
          LOGIN: ["LOGIN", "SANCTIONED", "REJECTED", "OTHERS"],
          SANCTIONED: [
            "LOGIN",
            "SANCTIONED",
            "DISBURSED",
            "REJECTED",
            "OTHERS",
          ],
          DISBURSED: ["LOGIN", "SANCTIONED", "DISBURSED", "REJECTED", "OTHERS"],
          REJECTED: ["LOGIN", "SANCTIONED", "DISBURSED", "REJECTED", "OTHERS"],
          OTHERS: ["LOGIN", "SANCTIONED", "DISBURSED", "REJECTED", "OTHERS"],
        },
        required: true,
        placeholder: "Please Enter",
      },
      {
        name: "disbursement_amount",
        label: "Disb. Amount",
        type: "number",
        placeholder: "Please enter",
        showWhen: (values) => values.application_status === "DISBURSED",
        required: true,
      },
      {
        name: "disbursement_date",
        label: "Disb. Date",
        type: "date",
        // disabledDate: (current) => {
        //   return current && current < moment().startOf("day");
        // },
        placeholder: "Please enter",
        showWhen: (values) => values.application_status === "DISBURSED",
        required: true,
      },
      {
        label: "Application Date",
        name: "application_date",
        type: "date",
        required: true,
        disabledDate: (current) => {
          return current && current > moment().endOf("day");
        },
        placeholder: "Please Enter",
      },
      {
        label: "Application No.",
        name: "application_number",
        type: "text",
        required: true,
        placeholder: "Please Enter",
      },
      {
        name: "disbursement_amount",
        label: "Disbursement Amt.",
        type: "number",
        placeholder: "Please Enter",
        showInModes: ["view"],
      },
      {
        name: "disbursement_date",
        label: "Disbursement Date",
        type: "date",
        placeholder: "Please enter",
        showInModes: ["view"],
      },
      {
        label: "Assigned By",
        name: "created_by_id",
        type: "text",
        placeholder: "Please Enter",
        showInModes: ["view"],
        disableOnEdit: true,
      },
      {
        label: "Tele Mobile No.",
        name: "tele_mobile_number",
        type: "text",
        placeholder: "Please Enter",
        showInModes: ["view"],
        disableOnEdit: true,
      },
      {
        name: "remark",
        label: "Remarks",
        type: "textarea",
        colspan: 24,
      },
    ],
  };

  const {
    appform,
    state: modalState,
    openModal,
    closeModal,
    handleValuesChange,
  } = useModalForm(modalConfigs, {});

  // ----------------- API helpers -----------------

  const getOpsApplications = (params = {}, reset) => {
    let payload = {};
    if (reset) {
      let defaultSearchData = Object.only(search, [
        "page",
        "limit",
        "order_by",
        "order_direction",
      ]);
      setSearch(defaultSearchData);
      payload = {
        ...defaultSearchData,
        ...params,
      };
    } else {
      payload = {
        ...search,
        ...params,
      };
    }

    props.apis.apiGetOpsApplications(payload).then(({ data, total }) => {
      setTableData(data);
      setIsFetching(false);
      setRowcount(total);
    });
  };

  // ----------------------------------------------------------------
  // ASSIGN TO
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [applicationId, setApplicationId] = useState(null);
  const [assigntoform] = Form.useForm();
  const [employees, setEmployees] = useState([]);

  const showModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    assigntoform.resetFields();
  };

  const openAssignedToModal = (record) => {
    console.log({ record });

    setApplicationId([record?.ops_application_id]);
    getEmployees();
    showModal();
  };

  const getEmployees = async () => {
    const res = await props.apis.apiGetAllEmployees({
      ...(isAdmin
        ? { role: _enum.ROUTE_PERSONAS.ops }
        : isOps
        ? { role: _enum.ROUTE_PERSONAS.ops }
        : {}),
    });
    if (res) {
      const employeeLists = res?.data;
      console.log({ employeeLists });
      setEmployees(employeeLists.options("employee_id", "full_name"));
    }
  };

  const handleAssignedTo = async (value) => {
    const payload = {
      assign_to: value?.assignedTo || "",
    };
    console.log("Success:", value, payload);
    if (value?.assignedTo === null || value?.assignedTo === "") {
      swal2.fire({
        title: "Please select any telecallers",
        icon: "info",
        iconColor: "#008AD1",
      });
      return;
    } else {
      const res = await props.apis.apiOpsAssignApplication(payload, {
        ops_application_id: applicationId,
      });
      if (res) {
        swal2.fire({
          title: "Application assigned successfully.",
          icon: "success",
          iconColor: "#234C9B",
          confirmButtonText: "Ok",
          timer: 4000,
        });
        assigntoform.resetFields();
        setIsModalOpen(false);
        getOpsApplications();
      }
    }
  };

  // ----------------- actions -----------------
  const view = async (record, modalType) => {
    const data = await props.apis.apiGetOpsApplicationById({
      ops_application_id: record.ops_application_id,
    });
    setEditData(data);
    openModal(modalType, "view", "View Application", { ...data });
  };

  const edit = async (record, modalType) => {
    const data = await props.apis.apiGetOpsApplicationById({
      ops_application_id: record.ops_application_id,
    });
    setEditData(data);
    openModal(modalType, "edit", "Edit Application", { ...data });
  };

  const handleAppModalSubmit = async (data) => {
    const payload = {
      ...Object.except(data, ["created_by_id", "tele_mobile_number"]),
    };

    if (modalState.mode === "edit") {
      await props.apis.apiUpdateOpsApplication(payload, {
        ops_application_id: editData.ops_application_id,
      });
      swal2.fire({
        title: "Application updated successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      getOpsApplications();
    } else if (modalState.mode === "add") {
      await props.apis.apiAddOpsApplication(payload);
      swal2.fire({
        title: "Application added successfully.",
        icon: "success",
        iconColor: "#008AD1",
        timer: 4000,
      });
      closeModal();
      getOpsApplications();
    }
  };

  // --------------------------------------------------------------

  const downloadExcel = async () => {
    let payload = {};
    props.apis.apiExportOpsApplication(payload).then(async (res) => {
      if (res) {
        let data = await res;
        let blob = new Blob([data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let link = document.createElement("a");
        link.href = URL.createObjectURL(blob);
        link.setAttribute("download", `Ops_Applications_Details.xlsx`);
        link.click();
      }
    });
  };

  const onSearch = (data, reset) => {
    console.log("onSearch on leads", data, reset);
    if (Object.keys(data).length === 0) {
      setSearch({
        ...data,
        ...search,
      });
      getOpsApplications(data, reset);
    } else {
      setSearch({
        ...data,
        ...search,
      });
      getOpsApplications(data, reset);
    }
  };

  // ----------------- lifecycle -----------------
  useEffect(() => {
    getOpsApplications();
  }, []);

  props.$setNode({
    props,
  });
  return (
    <>
      <MainPagetitle
        mainTitle="My Applications"
        pageTitle={"My Applications"}
        parentTitle={"Home"}
        pageIcon={imagepaths.SingleUserIconActive}
      />

      <div className="container-fluid position-relative pt-0 mt-4 mx-auto">
        <Flex
          gap="middle"
          align="center"
          justify="end"
          className="px-5 py-3 bg-md-white position-md-absolute end-0 top-0"
        ></Flex>
        <ApplicationCard />

        <div className="row">
          <div className="col-xl-12">
            <div className="card border-0">
              <div className="card-body p-0">
                <Flex
                  gap="middle"
                  align="center"
                  justify="end"
                  className="px-3 pt-3 pb-3"
                >
                  <Space size="small" split={<Divider type="vertical" />} wrap>
                    <AppButton
                      variant="excel"
                      onClick={(e) => downloadExcel(e)}
                    >
                      Download Excel
                    </AppButton>
                    <ApplicationSearch onSearch={onSearch} />
                    <Button
                      type="primary"
                      className="btn btn-primary"
                      htmlType="button"
                      onClick={() =>
                        openModal(
                          "applicationInfo",
                          "add",
                          "Create Application",
                          { application_status: "LOGIN", source: "SELF" }
                        )
                      }
                    >
                      Create New
                    </Button>
                  </Space>
                </Flex>

                <AppTable
                  data={tableData}
                  columns={columns}
                  onChange={(...arg) => {
                    const page = arg[0];
                    setSearch((prev) => ({
                      ...prev,
                      page: page.current,
                      limit: page.pageSize,
                    }));
                    getOpsApplications({
                      page: page.current,
                      limit: page.pageSize,
                    });
                  }}
                  total={rowcount}
                  reorder
                  loading={isFetching}
                  viewAction={(e) => view(e, "applicationInfo")}
                  editAction={(e) => edit(e, "applicationInfo")}
                  deletable={false}
                  assignedToLink={true}
                  assignedToLinkAction={(e) => openAssignedToModal(e)}
                />

                <AppFormModal
                  form={appform}
                  title={modalState.title}
                  open={modalState.open}
                  onValuesChange={handleValuesChange}
                  onClose={closeModal}
                  fields={modalState.fields}
                  onSubmit={handleAppModalSubmit}
                  mode={modalState.mode}
                  extraSections={[
                    {
                      title: "Application Logs",
                      type: "table",
                      data: editData?.logs,
                      columns: logColumns,
                      showIn: ["view"], // only show in view mode
                    },
                  ]}
                  persona={props?.$store?.user?.role}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ASSIGN TO MODAL */}
      <Modal
        title=""
        closable={{ "aria-label": "Custom Close Button" }}
        open={isModalOpen}
        onCancel={handleCancel}
        cancelButtonProps={{ style: { display: "none" } }}
        centered
        footer={null}
      >
        <Form
          form={assigntoform}
          layout="vertical"
          onFinish={handleAssignedTo}
          autoComplete="off"
        >
          <Form.Item
            label="Assign To"
            name="assignedTo"
            rules={[{ required: true, message: "Please select a value" }]}
          >
            <Select
              name="assignedTo"
              placeholder="Assign To"
              options={employees?.map((v) => ({
                value: v.key,
                label: v.label,
              }))}
              style={{ width: "100%" }}
              allowClear
              size="large"
              required={true}
            />
          </Form.Item>
          <Form.Item>
            <Button
              className="btn btn-primary"
              type="primary"
              htmlType="submit"
            >
              Submit
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default constore(Applications);
